// Tokeniza o cartão no navegador com a chave PÚBLICA (pk_) via POST /tokens —
// o MESMO endpoint que o tokenizecard.js oficial chama por baixo. O número do
// cartão NUNCA vai para o nosso backend — só o token retornado.
export async function tokenizeCard(publicKey, card) {
  const expYear = String(card.exp_year || '').trim();
  const body = {
    type: 'card',
    card: {
      number: String(card.number || '').replace(/\D/g, ''),
      holder_name: String(card.holder_name || '').trim(),
      exp_month: parseInt(card.exp_month, 10),
      // API aceita yy ou yyyy; mandamos yyyy pra não depender da interpretação.
      exp_year: parseInt(expYear.length === 2 ? `20${expYear}` : expYear, 10),
      cvv: String(card.cvv || '').trim(),
    },
  };
  const res = await fetch(`https://api.pagar.me/core/v5/tokens?appId=${encodeURIComponent(publicKey)}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    // Loga o erro cru e devolve o motivo real no toast (diagnóstico às cegas nunca mais).
    console.error('Pagar.me /tokens error:', res.status, data);
    const errs = data?.errors;
    let det = data?.message || '';
    if (errs && typeof errs === 'object') {
      det = Object.entries(errs)
        .map(([k, v]) => `${k}: ${Array.isArray(v) ? v.join('; ') : v}`)
        .join(' | ');
    }
    throw new Error(det ? `Cartão não validado: ${det}` : 'Não foi possível validar o cartão. Confira os dados.');
  }
  return data.id; // token_...
}
